import { render, staticRenderFns } from "./securityCode.vue?vue&type=template&id=68460a65&scoped=true&"
import script from "./securityCode.vue?vue&type=script&lang=js&"
export * from "./securityCode.vue?vue&type=script&lang=js&"
import style0 from "./securityCode.vue?vue&type=style&index=0&id=68460a65&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68460a65",
  null
  
)

export default component.exports